var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeerAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5742 27.5763V12.3093C19.5742 11.9699 19.2991 11.6948 18.9597 11.6948C18.6203 11.6948 18.3452 11.9699 18.3452 12.3093V27.5763C18.3452 27.9157 18.6203 28.1908 18.9597 28.1908C19.2991 28.1908 19.5742 27.9157 19.5742 27.5763Z",
    fill: "#191919",
    stroke: "black",
    strokeWidth: 0.336941
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0286 28.8832C21.0297 28.8512 21.0346 28.8181 21.0345 28.7861C21.0166 25.6769 19.3199 25.6247 19.0354 25.6378C19.0078 25.6391 18.9824 25.6391 18.9548 25.6378C18.6703 25.6247 16.9736 25.6768 16.9557 28.7861C16.9556 28.8181 16.9605 28.8512 16.9616 28.8832C16.9715 29.1654 16.6504 30.6107 9.05247 30.653C8.86639 30.654 8.70898 30.8048 8.70898 30.9909V32.6632C8.70898 32.8493 8.85984 33.0001 9.04593 33.0001H28.9442C29.1302 33.0001 29.2811 32.8493 29.2811 32.6632V30.9909C29.2811 30.8048 29.1237 30.654 28.9376 30.653C21.3398 30.6107 21.0188 29.1654 21.0286 28.8832Z",
    fill: "#E3D6C7",
    stroke: "black",
    strokeWidth: 0.336941
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3066 23.7906L29.0124 14.8789",
    stroke: "#191919",
    strokeWidth: 0.336941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7051 14.8789L33.4109 23.7906",
    stroke: "#191919",
    strokeWidth: 0.336941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5885 23.5234C25.1187 23.5234 24.7467 23.9074 24.8301 24.3697C25.0846 25.7801 26.0139 28.4582 29.4017 28.4582C32.7977 28.4582 33.6858 25.767 33.918 24.3594C33.9937 23.9003 33.6231 23.5234 33.1579 23.5234H25.5885Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.336941
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67969 6.90234L12.3855 15.814",
    stroke: "#191919",
    strokeWidth: 0.336941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 15.814L8.59443 6.90234",
    stroke: "#191919",
    strokeWidth: 0.336941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84431 15.9688C4.37909 15.9688 4.00846 16.3457 4.08419 16.8047C4.31644 18.2123 5.20453 20.9036 8.60055 20.9036C11.9884 20.9036 12.9176 18.2254 13.1721 16.815C13.2555 16.3527 12.8835 15.9688 12.4137 15.9688H4.84431Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.336941
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9552 13.8538C29.9547 13.8525 29.9528 13.8525 29.9522 13.8538V13.8538C29.9517 13.8551 29.9497 13.8552 29.9491 13.8539C29.8508 13.6152 29.6437 13.4039 29.3607 13.2875C28.8456 13.0754 28.2755 13.2566 28.0875 13.692C27.8995 14.1276 28.1646 14.6525 28.6798 14.8645V14.8645C28.6895 14.8685 28.6881 14.8821 28.6776 14.8833C28.4249 14.9125 28.1615 14.8815 27.9104 14.778C27.5204 14.6175 26.9024 13.7935 25.5055 13.2185C24.435 12.7779 22.0383 12.5059 19.0203 11.3103C18.8492 11.2425 18.6536 11.3221 18.5805 11.4915L18.4081 11.8908C18.3335 12.0635 18.4145 12.2636 18.5896 12.331C21.0248 13.2687 23.4967 13.509 24.5831 13.9176C26.6802 14.7065 27.1478 15.3369 27.6703 15.7942C28.1927 16.2516 29.542 16.2026 29.9468 15.2648C30.1493 14.7955 30.1377 14.2907 29.9552 13.8538Z",
    fill: "#E3D6C7",
    stroke: "black",
    strokeWidth: 0.336941
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4802 7.85748C11.0833 7.28245 10.0476 7.42587 9.65764 7.26534C9.40652 7.16203 9.20001 6.9997 9.04501 6.80277C9.03841 6.79438 9.04712 6.78375 9.057 6.78783V6.78783C9.572 6.99983 10.1422 6.81878 10.3302 6.38315C10.5182 5.94783 10.253 5.42279 9.73789 5.21086C9.4548 5.09431 9.15519 5.09698 8.91148 5.19512C8.91019 5.19564 8.90887 5.19419 8.90944 5.19292V5.19292C8.91002 5.19164 8.90866 5.19015 8.90735 5.19067C8.45965 5.36827 8.08136 5.71253 7.87881 6.18168C7.47396 7.11938 8.38011 8.09678 9.08026 8.14253C9.7804 8.18845 10.569 8.07515 12.6116 8.99031C13.6709 9.46483 15.5763 11.028 17.9681 12.0756C18.1366 12.1494 18.3325 12.0694 18.4056 11.9L18.578 11.5007C18.6526 11.328 18.5714 11.1284 18.3988 11.0546C15.4199 9.78054 13.5496 8.2977 12.4802 7.85748Z",
    fill: "#E3D6C7",
    stroke: "black",
    strokeWidth: 0.336941
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1871 8.59502C19.0718 8.42838 18.8429 8.43276 18.7339 8.60352C18.4038 9.1204 17.8203 10.2619 17.8203 11.8725C17.8203 14.1182 20.1775 14.1182 20.1775 11.8725C20.1775 10.253 19.5417 9.1078 19.1871 8.59502Z",
    fill: "#E3D6C7",
    stroke: "black",
    strokeWidth: 0.336941
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.9995,
    cy: 11.7968,
    rx: 0.89208,
    ry: 0.871021,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.336941
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeerAnalysis);
export default __webpack_public_path__ + "static/media/peerAnalysis.5211dc5f40646f8adb35ba0cb77c6b2f.svg";
export { ForwardRef as ReactComponent };